import React from "react";
import { ExternalLink } from "lucide-react";

export default function ThinkorSwimWebLink() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-slate-300 text-center">
      <ExternalLink className="w-6 h-6 text-blue-400 mb-2" />
      <p className="text-sm">
        ⚠️ ThinkorSwim does not allow embedding inside other applications.
      </p>
      <p className="text-xs text-slate-500 mt-2">
        You can open ThinkorSwim Web directly to access charts and trades.
      </p>
      <a
        href="https://trade.thinkorswim.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-3 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-4 py-2 rounded-md transition"
      >
        Open ThinkorSwim Web
      </a>
    </div>
  );
}
